import { render } from "./invoice-grid.vue?vue&type=template&id=bc4f7086"
import script from "./invoice-grid.vue?vue&type=script&lang=js"
export * from "./invoice-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__